import { SELECT_TEAM, BUILD_BREADCRUMBS, SELECT_DEAL_SIDEBAR_ID } from './ActionTypes';
import { List } from 'immutable';
import { deriveBreadcrumbPath } from '../utils/teamUtils';
import { setValueInLocalStorage } from '../utils/localStorageHelper';
import { SELECTED_TEAM_ID_STORAGE_KEY } from '../utils/localStorageKeys';
export function selectTeamAction(id) {
  return {
    type: SELECT_TEAM,
    payload: id
  };
}
export function selectTeam(id) {
  return dispatch => {
    setValueInLocalStorage(SELECTED_TEAM_ID_STORAGE_KEY, id);
    dispatch(selectTeamAction(id));
  };
}
export function buildBreadcrumbsAction(breadcrumbTrail) {
  return {
    type: BUILD_BREADCRUMBS,
    payload: breadcrumbTrail
  };
}
export function buildBreadcrumbs(id, teams) {
  return dispatch => {
    const breadcrumbTrail = deriveBreadcrumbPath(teams, Number(id));
    dispatch(buildBreadcrumbsAction(breadcrumbTrail));
  };
}
export function clearBreadcrumbs() {
  return dispatch => {
    setValueInLocalStorage(SELECTED_TEAM_ID_STORAGE_KEY, null);
    dispatch(selectTeamAction(null));
    dispatch(buildBreadcrumbsAction(List()));
  };
}
export function setDealSidebarOwnerId({
  dealSidebarId,
  isTeam,
  defaultTab
}) {
  return {
    type: SELECT_DEAL_SIDEBAR_ID,
    payload: {
      dealSidebarId,
      isTeam,
      defaultTab
    }
  };
}